<template>
  <VTBaseTemplate>
    <div class="w-100 h-100" style="position: absolute; top: 70px;">
      <b-container fluid>
        <b-row>
          <b-col>
            <h2 class="tw-mb-0 text-aegis-dk">
              Dataset: {{ id }} <!--<span v-if="admin_authorized"> / Original ID: {{original_ids}} </span> -->
              <!--<span v-if="data[0].DatasetID">(Dataset ID: {{data[0].DatasetID}})</span>-->
            </h2>
          </b-col>
          <b-col>
            <div style="float: right;">
              <b-button 
                class="ml-1 button-link" 
                :to="{name: 'vectraits-explorer'}" 
                variant="primary" 
                size="sm" 
                block
              >
                Return to List
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <hr />
      <!-- MODALS -->
      <!-- https://bootstrap-vue.org/docs/components/modal -->
      <!-- This modal shows when there is a problem with the data integrity. -->
      <b-modal
        id="warning-modal"
        v-model="warningModalShow"
        centered
        scrollable
        hide-footer
        no-close-on-backdrop
        title="Dataset Integrity"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <!-- <p class="my-4">{{modalText}}</p> -->
        <span v-html="modalText"></span>
        <b-button class="mt-3" block @click="warningModalShow = false">OK</b-button>
      </b-modal>
      <!-- This modal shows when the curator clicks the "Download Table Data" button-->
      <b-modal
          id="download-csv-modal"
          v-model="downloadCSVModal"
          centered
          scrollable
          hide-footer
          hide-header-close
          no-close-on-backdrop
          no-close-on-esc
          title="Data Use Policy"
          :header-bg-variant="'dark'"
          :header-text-variant="'light'">
          <span v-html="'It is important for data publishers and for the reputation of data users that data is cited correctly.  Citation information for each record can be found inside the downloaded file. We would be grateful for you to also <a href=https://www.vectorbyte.org/blog/how-to-cite-us target=_blank rel=noopener noreferrer style=text-decoration:underline;>cite the VectorByte resource</a>. Data should be presumed to be licensed under <a href=https://creativecommons.org/licenses/by-nc/4.0/ target=_blank rel=noopener noreferrer style=text-decoration:underline;>CC-BY-NC</a>, but data generators may have used a more permissive license. Please check with the original data generator when in doubt.'"></span>
          <br>
          <b-button class="mt-3" style="margin-right:20px; margin-left:100px;" @click="hideModal">Cancel</b-button>
          <b-button class="mt-3" variant='primary' @click="downloadCSV">Agree and Download</b-button>
      </b-modal>  
      <!-- This modal shows when the curator clicks the "DELETE" link. -->
      <b-modal
        id="delete-dataset-modal"
        v-model="deleteDatasetModalShow"
        centered
        scrollable
        no-close-on-backdrop
        title="Confirm Dataset Deletion"
        ok-title="Yes, Delete"
        @show="resetModal"
        @hidden="resetModal"
        @ok="handleOk"
        :header-bg-variant="'danger'"
        :header-text-variant="'light'">
        <!-- <p class="my-4">{{modalText}}</p> -->
        <span v-html="'Are you sure you want to delete this dataset?'"></span>
        <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          invalid-feedback="Confirmation is required"
          :state="deleteConfirmState"
        >
          <br>
          <b-form-checkbox
            id="delete-confirm-input"
            name="delete-confirm-chkbx"
            v-model="deleteConfirmed"
          >I'm sure.</b-form-checkbox>
        </b-form-group>
      </form>
      </b-modal>
      <!-- This modal shows while the dataset is being deleted. -->
      <b-modal
        id="warning-modal"
        v-model="deleteWorkingModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Deleting Dataset"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="'Please wait while the dataset is deleted. This may take several minutes.'"></span>
      </b-modal>
      <!-- This modal shows if there is a problem with the API call. -->
      <b-modal
        id="api-err-modal"
        v-model="apiErrModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Dataset Fetch Error"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="err_msg"></span>
        <b-button class="mt-3 button-link" :to="{name: 'vectraits-explorer'}" block>Return to  dataset list</b-button>
      </b-modal>
      <!-- This modal shows when the admin clicks the "Change Dataset ID" link. -->
      <b-modal
        id="change-dataset-id-modal"
        v-model="changeDatasetIdModalShow"
        centered
        scrollable
        title="Change Dataset ID"
        ok-title="Change ID"
        @show="resetChangeIdModal"
        @hidden="resetChangeIdModal"
        @ok="handleChangeIdOk"
        :header-bg-variant="'primary'"
        :header-text-variant="'light'">
        <div>
          <p><strong>Current Dataset ID:</strong> {{ id }}</p>
          <form ref="changeIdForm" @submit.stop.prevent="handleChangeIdSubmit">
            <b-form-group
              label="New Dataset ID:"
              label-for="new-dataset-id-input"
              invalid-feedback="Please enter a valid integer ID"
              :state="newDatasetIdState"
            >
              <b-form-input
                id="new-dataset-id-input"
                v-model="newDatasetId"
                type="number"
                placeholder="Enter new dataset ID"
                required
                :state="newDatasetIdState"
              ></b-form-input>
            </b-form-group>
          </form>
        </div>
      </b-modal>
      <!-- END MODALS -->
      <!-- DATASET DETAIL SECTION -->
      <b-container 
        fluid style="color: black; text-align: left; padding-left: 50px; padding-right: 50px;"
        class="data-table"
        v-if="data"
      >
        <b-row>
          <!--BEGIN LEFT COLUMN -->
          <b-col lg="7">
            
            <h4>Experimental Information</h4>
            <DataRow :title="'Dataset Number: '" :value="id" />
            <DataRow :title="'Trait Measured: '" :value="data[0].OriginalTraitName+' - '+data[0].OriginalTraitDef" />
            <DataRow :title="'Species: '" :value="data[0].Interactor1" />
            <b-row class="data-table-row" v-if="relatedByGenusDatasets.length">
              <b-col cols="3" class="mt-1 text-right border-right border-dark">More data on this genus: </b-col>
              <b-col cols="9" class="mt-1">
                <span v-b-toggle.collapse-genus-related>
                  <b-button @click="show_related_by_genus = !show_related_by_genus" variant="primary"
                  style="width: 250px; height: 40px;">
                    <span v-if="show_related_by_genus"> [-] <u>Hide related datasets</u></span>
                    <span v-else> [+] <u>See more datasets</u></span>
                  </b-button>
                </span>
               <b-collapse id="collapse-genus-related">
                  <router-link :to="{
                      name: 'vectraits-explorer',
                      query: {
                        field: 'Interactor1Genus',
                        operator:'contains',
                        term: data[0].Interactor1Genus
                      } 
                    }"
                  >
                    See datasets related by genus in VecTraits Explorer
                  </router-link>
                  <!-- <div class="" v-for="dataset in relatedByGenusDatasets" :key="dataset">
                    <router-link :to="{ name: 'vectraits-dataset', params: {id: dataset } }">
                      {{ dataset }}
                    </router-link>
                  </div> -->
                  <b-table
                    ref="relatedByGenusTable"
                    striped
                    hover
                    responsive
                    selectable
                    @row-selected="onRowSelected"
                    select-mode="single"
                    bordered
                    head-variant="light"
                    style="overflow-x: auto"
                    :items="relatedByGenusDatasets"
                    :fields="fieldsRelatedByGenus"
                    tbody-tr-class="vt-table-rows"
                  >
                    <!-- add tooltips for each cell -->
                    <template v-slot:cell()="data">
                      <span :title="data.value">{{ data.value }}</span>
                    </template>
                  </b-table>
                </b-collapse>
              </b-col>
            </b-row>
            <DataRow :title="'Replicates: '" :value="resolveListToFieldValue(this.columnArrays['Replicates'])"
              v-if="!nullColumnsList.includes('Replicates')" />
            <DataRow :title="'Life Stage: '" :value="data[0].Interactor1Stage" />
            <DataRow :title="'Ambient Temp (°C): '" :value="resolveListToFieldValue(this.columnArrays['AmbientTemp'])"
              v-if="!nullColumnsList.includes('AmbientTemp')" />
            <b-row class="data-table-row">
              <b-col cols="3" class="mt-1 text-right border-right border-dark">Type: </b-col>
              <b-col cols="9" class="mt-1">
                <span v-if="data[0].LabField === 'Lab' || data[0].LabField === 'lab'"> Labratory experiment </span>
                <span v-else-if="data[0].LabField ==='Field' || data[0].LabField === 'field'">
                  Field observation
                </span>
                <span v-else> Undefined Type </span>
              </b-col>
            </b-row>
            <DataRow :title="'Interacting Species: '" :value="data[0].Interactor1+' ( '+data[0].Interactor1Stage+' ) '" />
            <DataRow :title="'Cofactor: '" :value="resolveListToFieldValue(this.columnArrays['SecondStressorValue'])" 
              v-if="!nullColumnsList.includes('SecondStressorValue')"/>
            <b-row class="data-table-row">
              <b-col
                cols="3"
                class="mt-1 text-right border-right border-dark data-table-label-column"
              >Tag(s): </b-col>
              <b-col cols="9" class="mt-1">
                <span v-for="(item, index) in datasetTags" :key="index">
                  <b-link 
                    :to="{
                      name: 'vectraits-explorer',
                      query: {
                        field: 'Tags',
                        operator: 'contains',
                        term: item
                      }
                    }"
                    class="tag-link"
                  >
                    {{ item }}
                  </b-link>
                  <span v-if="index != datasetTags.length - 1">, </span>
                </span>
              </b-col>
            </b-row>
            <br>
            <h4>Data Source</h4>
            <b-row class="data-table-row">
              <b-col cols="12" class="mt-1"> {{ data[0].Citation }}<span v-if="data[0].FigureTable"> ( {{ data[0].FigureTable }} )</span></b-col>
            </b-row>
            <DataRow :title="'Imported by: '" :value="data[0].SubmittedBy" />
            <b-row class="data-table-row">
              <b-col cols="3" class="mt-1 text-right border-right border-dark">Dataset DOI: </b-col>
              <!-- This DOI link is going to need to be a little more robust than it is... -->
              <b-col cols="9" class="mt-1"><a v-bind:href=doiUrl(data[0].DOI) target="_blank"> <u>{{ doiString(data[0].DOI) }}</u></a></b-col>
            </b-row>
            <b-row class="data-table-row" v-if="relatedDatasets.length">
              <b-col cols="3" class="mt-1 text-right border-right border-dark">More data from this source: </b-col>
              <b-col cols="9" class="mt-1">
                <span v-b-toggle.collapse-related>
                  <b-button @click="show_related_by_citation = !show_related_by_citation" variant="primary"
                  style="width: 250px; height: 40px;">
                    <span v-if="show_related_by_citation"> [-] <u>Hide related datasets</u></span>
                    <span v-else> [+] <u>See more datasets</u></span>
                  </b-button>
                </span>
                <b-collapse id="collapse-related">
                  <router-link :to="{
                      name: 'vectraits-explorer',
                      query: {field: 'DOI', operator:'contains' , term: data[0].CuratedByDOI}
                    }"
                  >
                    See datasets related by DOI in VecTraits Explorer
                  </router-link>
                  <!-- <div class="" v-for="dataset in relatedDatasets" :key="dataset">
                    <router-link :to="{ name: 'vectraits-dataset', params: {id: dataset } }">
                      {{ dataset }}
                    </router-link>
                  </div> -->
                  <b-table
                    ref="relatedByDoiTable"
                    striped
                    hover
                    responsive
                    selectable
                    @row-selected="onRowSelected"
                    select-mode="single"
                    bordered
                    head-variant="light"
                    style="overflow-x: auto"
                    :items="relatedDatasets"
                    :fields="fieldsRelatedDatasets"
                    tbody-tr-class="vt-table-rows"
                  >
                    <!-- add tooltips for each cell -->
                    <template v-slot:cell()="data">
                      <span :title="data.value">{{ data.value }}</span>
                    </template>
                  </b-table>
                </b-collapse>
              </b-col>
            </b-row>
            <span v-if="data[0].CuratedByCitation && data[0].CuratedByDOI">
              <br>
              <!-- Curator Section -->
              <h4>Curation Project</h4>
              <b-row class="data-table-row">
                <b-col cols="12" class="mt-1"> {{ data[0].CuratedByCitation }}</b-col>
              </b-row>
              <b-row class="data-table-row">
                <b-col cols="3" class="mt-1 text-right border-right border-dark">Part of curation project: </b-col>
                <b-col cols="9" class="mt-1"><a v-bind:href=doiUrl(data[0].CuratedByDOI)> <u>{{ doiString(data[0].CuratedByDOI) }}</u></a></b-col>
              </b-row>
              <b-row class="data-table-row" v-if="relatedByCurationDatasets.length">
                <b-col cols="3" class="mt-1 text-right border-right border-dark">More data from this source: </b-col>
                <b-col cols="9" class="mt-1">
                  <span v-b-toggle.collapse-related-project>
                    <b-button @click="show_related_by_curation = !show_related_by_curation" variant="primary"
                    style="width: 250px; height: 40px;">
                      <span v-if="show_related_by_curation"> [-] <u>Hide related datasets</u></span>
                      <span v-else> [+] <u>See more datasets</u></span>
                    </b-button>
                  </span>
                  <b-collapse id="collapse-related-project">
                    <router-link :to="{
                        name: 'vectraits-explorer',
                        query: {field: 'DOI', operator:'contains' , term: data[0].CuratedByDOI} 
                      }"
                    >
                      See datasets related by CuratedbyDOI in VecTraits Explorer
                    </router-link>
                    <b-table
                      ref="relatedByCurationTable"
                      striped
                      hover
                      responsive
                      selectable
                      @row-selected="onRowSelected"
                      select-mode="single"
                      bordered
                      head-variant="light"
                      style="overflow-x: auto"
                      :items="relatedByCurationDatasets"
                      :fields="fieldsRelatedDatasets"
                      tbody-tr-class="vt-table-rows"
                    >
                      <template v-slot:cell()="data">
                        <span :title="data.value">{{ data.value }}</span>
                      </template>
                    </b-table>
                  </b-collapse>
                </b-col>
              </b-row>
            </span>
            <br v-if="datasetNotes[0]">
            <h4 style="display: inline;" v-if="datasetNotes[0]">Notes </h4>
            <span v-b-toggle.show-three-notes>
            <span style="display: inline;" v-if="datasetNotes.length > 3" @click="showThreeNotes = !showThreeNotes">
                <span v-if="showThreeNotes"> [+] <u>See more...</u></span>
                <span v-else> [-] <u>See less...</u></span>
              </span>
            </span>
              <span v-if="showThreeNotes">
                <b-row class="data-table-row" v-for="note in firstThreeNotes" :key="note.idx">
                  <b-col cols="12" class="mt-1" > {{ note }} </b-col>             
                </b-row>
              </span>
              <span v-else>
                <b-collapse id="show-three-notes">
                  <b-row class="data-table-row" v-for="note in datasetNotes" :key="note.idx">
                    <b-col cols="12" class="mt-1" > {{ note }} </b-col>             
                  </b-row>
                </b-collapse>
              </span>
            <br>
            <h4>Data</h4>
            <b-row>
              <b-col>
                <div v-if="data.length > -1" style="position: absolute; right: 0;  top: -25px;">
                  {{ data.length }} total records in dataset
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-table
                ref="table"
                striped 
                hover 
                sticky-header="500px"
                responsive
                selectable
                select-mode='single'
                bordered
                head-variant="light"
                no-border-collapse

                :items="data"
                :fields="fields"
                tbody-tr-class="vt-table-row"
              >
                <template #table-busy>
                  <div class="text-danger my-2">
                    <b-spinner class="align-left"></b-spinner>
                    <strong>&nbsp;Loading...</strong>
                  </div>
                </template>
                <template v-slot:head()="field">
                    <span :title="field.field.title" style="font-size: small; white-space: nowrap;">
                        {{ field.label }}
                    </span>
                </template>
                <template v-slot:cell()="data">
                  <span  :title='data.value'>{{ data.value}}</span>
                </template>
              </b-table>
              <div style="float: right;">
                <b-button class="ml-1" variant="primary" style="float: right;" size="sm" @click="downloadCSVModal = true">
                  Download Table Data
                </b-button>
              </div>
            </b-row>
            <br>
            <h4>Additional Information</h4>
            <b-row class="data-table-row" v-for="(field, index) in additionalDataList" :key="`field-${index}`">
              <b-col cols="3" class="mt-1 text-right border-right border-dark data-table-label-column">
                <span :title="fieldDefDict[field.toLowerCase()]">{{field}}: </span>
              </b-col>
              <b-col cols="9" class="mt-1"> {{ columnArrays[field][0] }}</b-col>
            </b-row>

          </b-col>
          <!--END LEFT COLUMN -->
          <!--BEGIN RIGHT COLUMN -->
          <b-col lg="5">
            <b-row>
              <b-col v-if="XAxis != 'Unplottable'">
                <HighChart
                  :chartSeriesArray="chartSeriesArray"
                  :key="componentKey"
                />
                <div style="float: right;" v-if="canCondenseGraph">
                  <b-button
                    v-if="chartIsMultiSeries"
                    class="both-square"
                    variant="primary"
                    @click="condenseToSingleSeries"
                    size="sm"
                  >Merge Graph</b-button>
                  <b-button
                    v-else
                    class="both-square"
                    variant="primary"
                    @click="splitGraphToSeries"
                    size="sm"
                  >
                    <span v-if="seriesCategory == 'Location'">
                      Split by Location
                    </span>
                    <span v-else-if="seriesCategory == 'SecondStressorValue'">
                      Split by Second Stressor
                    </span>
                    <span v-else>
                      Split by {{ seriesCategory }}
                    </span>
                  </b-button>
                </div>
                <div style="float: right;">
                  <b-button
                    v-if="canSwitchXAxis"
                    class="right-square"
                    variant="primary"
                    @click="switchXAndCategory"
                    size="sm"
                  >Switch X Axis and Series Category</b-button>
                </div>
              </b-col>
              <b-col v-else class="mt-4" style="margin:10px; border: 1px solid;"> 
                <center><h3 > We can’t plot this trait yet. </h3></center>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="mapDataExists"> 
                <Map 
                  :key="componentKey"
                  :mapData="mapArray"
                />
              </b-col>
            </b-row>

            <h4 v-if="admin_authorized">Admin Tools</h4>
            <b-row class="data-table-row ml-1" v-if="admin_authorized">
              <b-col cols="3" class="mt-1 text-right border-right border-dark">Citation: </b-col>
              <b-col cols="6" class="mt-1">
                <router-link :to="{ name: 'vectraits-citation-edit', params: { id: this.id } }" >
                  <u>Click to edit citations, DOIs, embargo dates, tags, curators...</u>
                </router-link>
              </b-col>
            </b-row>
            <b-row class="data-table-row ml-1" v-if="admin_authorized">
              <b-col cols="3" class="mt-1 text-right border-right border-dark">Delete Dataset: </b-col>
              <b-col cols="6" class="mt-1">
                <span @click="deleteDatasetModalShow = true" >
                  <u>Delete</u>
                </span>
              </b-col>
            </b-row>
            <b-row class="data-table-row ml-1" v-if="admin_authorized">
              <b-col cols="3" class="mt-1 text-right border-right border-dark">Dataset ID: </b-col>
              <b-col cols="6" class="mt-1">
                <span @click="changeDatasetIdModalShow = true" >
                  <u>Change Dataset ID</u>
                </span>
              </b-col>
            </b-row>
          </b-col>
          <!--END RIGHT COLUMN -->
        </b-row>
        <!--BEGIN BOTTOM ROW -->
        <b-row>
          <b-col>
            <div style="float: right;">
              <b-button 
                class="ml-1 button-link" 
                :to="{name: 'vectraits-explorer'}" 
                variant="primary" 
                size="sm" 
                block
              >
                Return to List
              </b-button>
            </div>
          </b-col>
        </b-row>
        <!--END BOTTOM ROW -->
      </b-container>
    </div>
    
  </VTBaseTemplate>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import { mapState } from "vuex";
import * as _ from "lodash";
import HandleErrors from "@/utilities/handle-errors";
import VTBaseTemplate from "@/layouts/VTBaseTemplate.vue";
import DataRow from "@/components/details/DataRow.vue"
import HighChart from "@/components/charts/HighChart.vue";
import Map from "@/components/map/VBMap.vue";


export default {
  name: "vectraits-dataset",
  mixins: [VTBaseTemplate],
  components: {
      VTBaseTemplate,
      HighChart,
      Map,
      DataRow,
  },
  props: {
    id: String,
    embargo_key: {
      type: String,
      require: false,
    }
  },
  data(){
    return{
      // admin_authorized: false,
      data: undefined, // initialize as undefined so that the v-if on the b-container will work properly. 
      // https://forum.vuejs.org/t/error--vm-data-type-is-undefined-but-its-defined/8032/4
      columnArrays: [], // an dictionary of arrays. Each array contains an array of each column's data.
      datasetTags: [], // a list of tags for this dataset
      datasetNotes: [], // a formatted list of notes.
      showThreeNotes: true, // When page is loaded, show only the first 3 notes. Can toggle this off to show all.
      nullColumnsList: [], // a list of the names of columns containing no data.
      sameColumnsList: [], // a list of the names of columns that contain the same value on every row
      differentColumnsList: [], // a list of the names of columns that contain a different value on every row
      fieldDefDict: undefined,
      err_msg: '',
      componentKey: 0, // used to re-render map & chart components
      chartIsMultiSeries: true,
      canCondenseGraph: false,
      show_related_by_citation: false,
      show_related_by_curation: false,
      show_related_by_genus: false,
      mapArray: undefined,
      chartSeriesArray: [], // 
      relatedDatasets: [], // IDs of datasets with the same citation
      fieldsRelatedDatasets:[
        {
          key: "datasetid",
          tdClass: "text-truncate vt-table-cell text-underline",
        },
        {
          key: "originaltraitname",
          tdClass: "text-truncate vt-table-cell-wide",
        },
        {
          key: "interactor1",
          tdClass: "text-truncate vt-table-cell-wide",
        },
      ],
      relatedByGenusDatasets: [], // IDs of datasets with the same genus
      relatedByCurationDatasets: [], // IDs of datasets with the same curation project
      fieldsRelatedByGenus:[
        {
          key: "datasetid",
          tdClass: "text-truncate vt-table-cell text-underline",
        },
        {
          key: "originaltraitname",
          tdClass: "text-truncate vt-table-cell-wide",
        },
      ],
      fields: [], // dynamically populated by buildFieldsArray()
      XAxis: undefined,
      seriesCategory: '',
      modalText: 'There may be issues with this dataset.',
      warningModalShow: false,
      apiErrModalShow: false,
      downloadCSVModal: false,
      deleteDatasetModalShow: false,
      deleteWorkingModalShow: false,
      deleteConfirmed: null,
      deleteConfirmState: null,
      // Change Dataset ID modal properties
      changeDatasetIdModalShow: false,
      newDatasetId: '',
      newDatasetIdState: null
    };
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    original_ids:function () {
      return _.uniq(this.columnArrays['OriginalID']);
    },
    // doiString: function () {
    //   let string = this.data[0].DOI;

    //   if (string == null) {
    //     return null;
    //   }

    //   if (string.startsWith('http://')){
    //     return string.replace('http://', '');
    //   } else if (string.startsWith('https://')){
    //     return string.replace('https://', '');
    //   }

    //   return string;
    // },
    admin_authorized : function() {
      const that = this;
      // store.getters['user/inMyGroups'](['admin', 'uploader', 'collaborator'])
      let groups = ['admin', 'uploader', 'collaborator'];
      return Boolean((_.intersection(that.myGroups, groups)).length);
    },
    mapDataExists: function () {
      if (
          this.allArrayItemsNull(this.columnArrays['Latitude']) ||
          this.allArrayItemsNull(this.columnArrays['Longitude'])
         ){
        return false;
      }
      else{
        return true;
      }
    },
    canSwitchXAxis: function() {
      if(
          (
            (this.XAxis == "AmbientTemp") || (this.XAxis == "SecondStressorValue") // may need to add Interactor1Temp to this
          ) &&
          (
            (this.seriesCategory == "AmbientTemp") || (this.seriesCategory == "SecondStressorValue")
          )
        ){
        return true;
      }
      else {
        return false;
      }
    },
    additionalDataList: function () {
      // The fields under the table are meant to display all of the columns which have the same value in each row.
      // However, we don't want to show the fields that are already shown in the Experimental Info or Data Source.
      let list = [];

      let fieldsToExclude = [
        'OriginalID',
        'OriginalTraitName',
        'OriginalTraitDef',
        'Replicates',
        'AmbientTemp',
        'AmbientTempUnit',
        'LabField',
        'Citation',
        'FigureTable',
        'SubmittedBy',
        'ContributorEmail',
        'DOI',
        'Notes',
        'DatasetID',  // This one should always be the same but we don't want to see if in the 'Additional Info'
        'IndividualID',  // This one will frequently be blank, and should never be repeated in the same dataset.
        'DefaultChartXaxis',
        'DefaultChartCategory'
      ]

      list = this.sameColumnsList.filter(e => !fieldsToExclude.includes(e));
      return list;
    },
    firstThreeNotes: function () {return this.datasetNotes.slice(0,3)},
  },
  watch: {
    id:function(){
      this.getDataset();
    },
  },
  created() {
    document.title = "VecTraits Dataset: " + this.id;
    this.getFieldDefsandDataset();
    // this.getDataset(); // called in the method above
  },
  methods: {
    hideModal() {
      this.downloadCSVModal = false;
    },
    forceComponentRender() {
      return this.componentKey++;
    },
    allArrayItemsEqual: function (arr) {
      return arr.every(val => val === arr[0]);
    },
    allArrayItemsNull: function(arr) {
      return arr.every(val => val === undefined || val === null);
    },
    columnsAreEqual (col1, col2) {
      for (let i =0; i < col1.length; i++) {
        if (col1[i] != col2[i]) { // can't use "col1[i] !== col2[i]" which will fail on 18.0 and 18 for example.
          return false;
        }
      }
      return true;
    },
    resolveListToFieldValue: function (arr) {
      if (this.allArrayItemsNull(arr)){
        return null;
      }
      else if (this.allArrayItemsEqual(arr)){
        return arr[0];
      }
      else {
        var min = Math.min(...arr); // ... convert array into distinct vars and send them to func
        var max = Math.max(...arr);
        var valuestring = "min: " + min + ", max: " + max;
        return valuestring;
      }
    },
    getColumnArrays(data) {
      // convert rows (horizontal data) into arrays of column data (vertical data)
      let columnArrays = [];
      let sameColumnsList = [];
      let nullColumnsList = [];
      let differentColumnsList = [];
      let column_names = Object.getOwnPropertyNames(data[0]);
      
      // for each column in the dataset:
      column_names.forEach(function(column) {
        // create an array to store the current column's data
        columnArrays[column] = [];
        // for each object (row) in the dataset:
        data.forEach(function(obj) {
          // get this row's value belonging to the current column and push it into the current column's array
          columnArrays[column].push(obj[column]); 
        });
      });

      // Build 3 lists to keep track of arrays with null, same, or different values.
      const that = this;
      column_names.forEach(function(column) {
        if (that.allArrayItemsNull(columnArrays[column])){
          nullColumnsList.push(column);
        }
        else if(that.allArrayItemsEqual(columnArrays[column])) {
          sameColumnsList.push(column);
        }
        // else if(!that.allArrayItemsEqual(columnArrays[column])){
        else {
          differentColumnsList.push(column);
        }
      });
      // there will be an element called __obj__ at the end of differentColumnsList--remove it:
      differentColumnsList.pop();

      this.columnArrays = columnArrays;
      this.sameColumnsList = sameColumnsList;
      this.nullColumnsList = nullColumnsList;
      this.differentColumnsList = differentColumnsList;
    },
    formatNotes(notesArray) {
      let newNotesArray = [];

      notesArray.forEach(function(note) {
        // if note isn't null
        if (note) {
          // if note not already in newNotesArray
          if ( !newNotesArray.includes(note) ) {
            // push note into nnewNotesArray
            newNotesArray.push(note);
          }
        }
      });

      return newNotesArray;
    },
    checkColumnIntegrity(column) {
      if (!this.allArrayItemsEqual(this.columnArrays[column])) {
        this.modalText += " <br>The <b>" + column + "</b> column lists more than one value.";
        this.warningModalShow = true;
      }
    },
    checkDatasetIntegrity() {
      this.checkColumnIntegrity('OriginalTraitName');
      this.checkColumnIntegrity('OriginalTraitDef');
      this.checkColumnIntegrity('LabField');
      this.checkColumnIntegrity('Interactor1');
      this.checkColumnIntegrity('Interactor1Stage');
      this.checkColumnIntegrity('SecondStressor');
      this.checkColumnIntegrity('Citation');
      this.checkColumnIntegrity('FigureTable');
      this.checkColumnIntegrity('SubmittedBy');
      this.checkColumnIntegrity('DOI');
      this.checkColumnIntegrity('ContributorEmail');
    },
    deleteDataset() {
      this.deleteWorkingModalShow = true;
      // return HTTP.post(`/api/vectraits-delete-dataset/${this.id}/`)
      return HTTP.post(`/api/vectraits-dataset-delete/${this.id}/`)
      .then(response => {
        this.deleteWorkingModalShow = false;
        this.$router.push({name: 'vectraits-explorer'})
        return response;
      })
      .catch(error => {
        this.deleteWorkingModalShow = false;
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
        return [];
      });
    },
    buildURL(url) {
      let return_url = url
      if (this.embargo_key) {
        return_url += `?embargo_key=${this.embargo_key}`;
      }
      return return_url;
    },
    getDataset() {
      const that = this;

      return HTTP.get(that.buildURL(`/api/vectraits-dataset/${this.id}/`))
      .then(response => {
        that.data = response.data.results;
        // handle data after we have retrieved it
        that.getColumnArrays(that.data);
        that.fields = that.buildFieldsArray(that.differentColumnsList);
        that.mapArray = this.getMapArray(that.data);
        that.XAxis = that.data[0].DefaultChartXaxis;
        that.seriesCategory = that.data[0].DefaultChartCategory;
        that.checkGraphCanCondense();
        that.chartSeriesArray = this.getChartData(this.data, this.XAxis, this.seriesCategory);
        that.checkDatasetIntegrity();
        that.datasetNotes = this.formatNotes(this.columnArrays['Notes']);

        // related API calls
        that.getTags();
        that.getRelatedByCitationRecords();
        that.getRelatedByCurationRecords();
        that.getRelatedByGenusRecords();

        that.forceComponentRender() // when this.id changes, the graph and map components will rerender
      })
      .catch(error => {
        that.err_msg = HandleErrors.HandleErrors(error);
        that.apiErrModalShow = true;
      });
    },
    downloadCSV(){
      this.downloadCSVModal = false;
      const fd = new FormData();
      fd.append('ids', this.id);
      fd.append('return_as', 'csv');

      HTTP.post(`/api/vectraits-get-populated-fields/`, fd)
      .then((response) => {
        var fileURL = window.URL.createObjectURL(
          new Blob([response.data])
        );
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        // Construct file name: VByte_originalid_ Originaltraitname_X[XAxisTitle].csv
        let x = '';
        if (this.XAxis == 'SecondStressorValue'){
          x = this.data[0].SecondStressor;
        }
        else if (this.XAxis == 'AmbientTemp'){ 
          x = 'Ambient Temp';
        }
        else if (this.XAxis == 'Interactor1Temp'){ 
          x = 'Interactor 1 Temp';
        }
        else {
          x = "Unplottable";
        }
        var fileName = "VByte_" + this.data[0].DatasetID + "_" + this.data[0].OriginalTraitName + "_X[" + x + "].csv";
        fileLink.setAttribute("download", fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch((error) => {
        this.err_msg = HandleErrors.HandleErrors(error);
        this.apiErrModalShow = true;
      });
    },
    getFieldDefsandDataset() {
      const that = this;

      HTTP.get(`/api/column-definitions/`)
      .then(response => {
        let fieldDefs = response.data;

        let def_dict = {};
        
        fieldDefs.forEach(function(obj) {
          def_dict[obj.field_name] = obj.definition;
        })

        that.fieldDefDict = def_dict;

        that.getDataset();
      })
      .catch((error) => {
        that.err_msg = HandleErrors.HandleErrors(error);
        that.apiErrModalShow = true;
      });
    },
    getRelatedByCitationRecords() {
      const that = this;

      return HTTP.get(`/api/vectraits-get-related-datasets/${this.id}/`)
      .then(response => {
        // that.relatedDatasets = response.data.results.DatasetIDList;
        that.relatedDatasets = response.data.results;
      })
      .catch(error => {
        // this.err_msg = HandleErrors.HandleErrors(error);
        HandleErrors.HandleErrors(error)
        return [];
      });
    },
    getRelatedByCurationRecords() {
      const that = this;

      return HTTP.get(`/api/get_related_by_curation_project/${this.id}/`)
      .then(response => {
        that.relatedByCurationDatasets = response.data.results;
      })
      .catch(error => {
        // this.err_msg = HandleErrors.HandleErrors(error);
        HandleErrors.HandleErrors(error)
        return [];
      });
    },
    getRelatedByGenusRecords() {
      const that = this;

      return HTTP.get(`/api/vectraits-get-related-datasets-by-genus/${this.id}/`)
      .then(response => {
        // that.relatedByGenusDatasets = response.data.results.DatasetIDList;
        that.relatedByGenusDatasets = response.data.results;
      })
      .catch(error => {
        // this.err_msg = HandleErrors.HandleErrors(error);
        HandleErrors.HandleErrors(error)
        return [];
      });
    },
    getTags() {
      const that = this;

      return HTTP.get(`/api/vectraits-get-dataset/${this.id}/`)
      .then(response => {
        // Handle tags as array - ensure it's always an array
        that.datasetTags = Array.isArray(response.data.results['tags']) ? response.data.results['tags'] : [];
      })
      .catch(error => {
        // If tags endpoint fails, just log it and continue without tags
        HandleErrors.HandleErrors(error)
        that.datasetTags = [];
        return [];
      });
    },
    doiString: function (doi_string){
      if (doi_string != null) {
        let doi_regex = /.*(doi.org\/)/i;
        
        // /10.123456/
        if (doi_string.match(doi_regex) == -1 && 
        !(doi_string.startsWith('http') || doi_string.startsWith('https'))){
          return doi_string;
        }
        
        // http://doi.org/9999
        if (doi_string.match(doi_regex) != -1) {
          let new_string = doi_string.replace(doi_regex, '');
          if (new_string.startsWith('10.')){
            return new_string
          } else{
            return '10.' + new_string;
          }
          
        }
        // 
        return doi_string
      }else {
        return "No DOI";
      }
    },
    doiUrl: function (doi_string) {
      if (doi_string != null) {
        let doi_regex = /.*(doi.org\/)/i;
        
        // /10.123456/
        if (doi_string.match(doi_regex) == -1 && 
        !(doi_string.startsWith('http') || doi_string.startsWith('https'))){
          return 'https://www.doi.org/' + doi_string;
        }
        
        // http://doi.org/9999
        if (doi_string.match(doi_regex) != -1) {
          let new_string = doi_string.replace(doi_regex, '');
          if (new_string.startsWith('10.')){
            return 'https://www.doi.org/' + new_string;
          } else{
            return 'https://www.doi.org/10.' + new_string;
          }
        }
        //
        return doi_string
      }else {
        return "";
      }
    },
    onRowSelected(items) {
      this.$router.push({
        name: "vectraits-dataset",
        params: { id:  items[0]["datasetid"]},
      });
    },
    buildFieldsArray(fields) {

      // convert each element to an object containing the field name as a key, a sortable key, and tdclass:
      // ie. convert "OriginalID" to "{ key: 'OriginalID', sortable: true, tdClass: 'text-truncate vt-table-cell' },"
      // let field_list = Object.keys(data[0]);

      const that = this;

      let field_array = [];

      fields.forEach(function(fieldName) {
        let field_dict = {};
        field_dict['key'] = fieldName;
        field_dict['sortable'] = true;
        field_dict['tdClass'] = 'text-truncate vt-table-cell';
        field_dict['title'] = that.fieldDefDict[fieldName.toLowerCase()];
        field_array.push(field_dict);
      });

      // remove the "id" field from the data table
      field_array.splice(0, 1);

      return field_array;
    },
    getMapArray: function(data) {
      const mapDataArray = [];

      data.forEach(function(obj) {
        const location = [];
        location[0] = obj['Latitude'];
        location[1] = obj['Longitude'];
        location[2] = obj['Location'];
        location[3] = obj['LocationDate'];

        mapDataArray.push(location);
      });

      // mapDataArray will likely contain many duplicate arrays at this point.
      // JS will evaluate each array as unique even if they are identical so
      // using a set directly on the array won't remove duplicate elements.
      // Convert array to JSON strings and load into the set.

      let set = new Set(mapDataArray.map(JSON.stringify));

      return Array.from(set).map(JSON.parse);
    },
    checkGraphCanCondense: function() {
      const multSecondStressors = !this.allArrayItemsEqual(this.columnArrays['SecondStressorValue']);
      const multLocations = this.mapArray.length > 1;

      let multTempVals = false;
      if (this.XAxis == 'AmbientTemp' || this.XAxis == 'Interactor1Temp'){
        if (!this.allArrayItemsEqual(this.columnArrays[this.XAxis])) {
          multTempVals = true;
        }
      }

      if(multTempVals && multSecondStressors && !multLocations){
        this.canCondenseGraph = true;
      }
      else if(multTempVals && multLocations && !multSecondStressors){
        this.canCondenseGraph = true;
      }
      else if(multSecondStressors && multLocations && !multTempVals){
        this.canCondenseGraph = true;
      }
    },
    getChartData (data, x, seriesCategory) {
      const chartDataRecords = [];
      const seriesList = [];
      const seriesByCategory = [];

      data.forEach(function(obj) {
        const coordinate = [];
        coordinate[0] = obj['OriginalID'];
        coordinate[1] = obj['OriginalTraitName'];
        coordinate[2] = obj['OriginalTraitValue'];
        coordinate[3] = obj['OriginalTraitUnit'];
        coordinate[4] = obj['OriginalErrorPos'];
        coordinate[5] = obj['OriginalErrorNeg'];
        
        if (x == "AmbientTemp"){
          coordinate[6] = "Ambient Temperature";
          coordinate[7] = obj['AmbientTemp']; // the ambient temp value
          coordinate[8] = obj['AmbientTempUnit'];
        }
        if (x == "Interactor1Temp"){
          coordinate[6] = "Interactor 1 Temperature";
          coordinate[7] = obj['Interactor1Temp']; // the ambient temp value
          coordinate[8] = obj['Interactor1TempUnit'];
        }
        else if (x == "SecondStressorValue"){
          coordinate[6] = obj['SecondStressor']; // the "name" of the secondary stressor
          coordinate[7] = obj['SecondStressorValue'];
          coordinate[8] = obj['SecondStressorUnit'];
        }

        // sort out the series name
        if (seriesCategory == 'SecondStressorValue'){
          coordinate[9] = obj['SecondStressor'] + " (" + obj['SecondStressorUnit'] + ")";
        }
        else if (seriesCategory == 'AmbientTemp'){
          coordinate[9] = "Ambient Temperature";
        }
        else if (seriesCategory == 'Interactor1Temp'){
          coordinate[9] = "Interactor 1 Temperature";
        }
        else if (seriesCategory == "Location"){
          coordinate[9] = "Location";
        }
        else {
          coordinate[9] = seriesCategory;
        }
        coordinate[10] = obj[seriesCategory]; // either Location or SecondStressorvalue

        if(seriesCategory){
          // get all unique instances of the category from the data
          if (!seriesList.includes(obj[seriesCategory])){
            seriesList.push(obj[seriesCategory]);
          }
        }
        
        chartDataRecords.push(coordinate);
      });

      // split up by category.
      // a category is an instance of AmbientTemp, SecondStressorvalue, or Location
      seriesList.forEach(function(category) {
        const series = []

        chartDataRecords.forEach(function(obj){
          if(obj[10] == category){
            series.push(obj);
          }
        });
        seriesByCategory.push(series);
      });

      return seriesByCategory;
    },
    switchXAndCategory() {
      let temp = this.XAxis;
      this.XAxis = this.seriesCategory;
      this.seriesCategory = temp;

      // {OID, Y-name, Y-val, Y-unit, Errorpos, Errorneg, Location, X-name, X-val, X-unit}

      this.chartSeriesArray = this.getChartData(this.data, this.XAxis, this.seriesCategory);
      
      this.forceComponentRender(); // force the chart to update.
    },
    condenseToSingleSeries() {
      const newChartSeriesArray = [];
      const singleSeries = [];

      this.chartSeriesArray.forEach(function(series) {
        series.forEach(function(obj){
          obj[10] = 'Combined';
          singleSeries.push(obj);
        });
      });

      newChartSeriesArray.push(singleSeries);
      this.chartSeriesArray = newChartSeriesArray;
      this.chartIsMultiSeries = false;
      this.forceComponentRender(); // force the chart to update.
    },
    splitGraphToSeries() {
      this.chartSeriesArray = this.getChartData(this.data, this.XAxis, this.seriesCategory);
      this.chartIsMultiSeries = true;
      this.forceComponentRender(); // force the chart to update.
    },
    onCitationButtonClicked() {
      this.$router.push({name: 'vectraits-edit-citation', params: {id: this.id }});
    },
    resetModal() {
      this.deleteConfirmed = ''
      this.deleteConfirmState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleSubmit() {
      // Exit when the form isn't valid
      if (!this.deleteConfirmed) {
        this.deleteConfirmState = false;
        return;
      }
      // Hide the modal manually
      this.deleteDatasetModalShow = false;
      this.deleteDataset();
      // this.$router.push({name: 'vectraits-exporer'});
    },
    /**
     * Reset the change dataset ID modal form
     */
    resetChangeIdModal() {
      this.newDatasetId = '';
      this.newDatasetIdState = null;
    },
    /**
     * Handle the OK button click in the change dataset ID modal
     */
    handleChangeIdOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleChangeIdSubmit();
    },
    /**
     * Handle the form submission for changing dataset ID
     */
    handleChangeIdSubmit() {
      // Validate the input
      if (!this.newDatasetId || this.newDatasetId === '') {
        this.newDatasetIdState = false;
        return;
      }
      
      // Check if the new ID is different from the current ID
      if (parseInt(this.newDatasetId) === parseInt(this.id)) {
        this.newDatasetIdState = false;
        this.err_msg = 'New dataset ID must be different from the current ID';
        this.apiErrModalShow = true;
        return;
      }
      
      // Hide the modal manually
      this.changeDatasetIdModalShow = false;
      this.changeDatasetId();
    },
    /**
     * Make API call to change the dataset ID
     */
    changeDatasetId() {
      const that = this;
      const newId = parseInt(this.newDatasetId);
      
      return HTTP.get(`/api/vectraits-reset-dataset-id/${this.id}/${newId}/`)
      .then(response => {
        // Show success message
        that.err_msg = `Dataset ID successfully changed from ${that.id} to ${newId}`;
        that.apiErrModalShow = true;
        
        // Update the current page ID and redirect to the new dataset page
        setTimeout(() => {
          that.$router.push({ 
            name: 'vectraits-dataset', 
            params: { id: newId },
            query: that.embargo_key ? { embargo_key: that.embargo_key } : {}
          });
        }, 2000);
        
        return response;
      })
      .catch(error => {
        that.err_msg = HandleErrors.HandleErrors(error);
        that.apiErrModalShow = true;
        return [];
      });
    }
  },
};
</script>

<style>
  h1, h2, h3, h4, a, p, text, label, table {
      color: black !important;
      text-shadow: none;
  }

  .button-link {
    color: white !important;
  }

  .data-table .data-table-row:nth-child(even){
      background-color: #CFD5E9;
  }
  .data-table .data-table-row:nth-child(odd){
      background-color: #E9EBF4;
  }
  .data-table .data-table-row{
      border-top: 2px solid white;
      min-width: 535px;
  }

  .data-table-label-column{
    
    white-space: nowrap;      /*keep text on one line */
    overflow: hidden;         /*prevent text from being shown outside the border */
    text-overflow: ellipsis;  /*cut off text with an ellipsis*/
  }

  .unplottable {
    color: red !important;
  }

  .vertical-center {
    margin: 0;
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }

  .right-square {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .both-square {
    border-radius: 0px;
  }



  .leaflet-container {
    z-index:90;
  }
</style>